<template>
  <div>
    <div class="row">
      <div>
        <b-modal
          id="modalPopover"
          ok-title-html="متوجه شدم "
          ok-only
          title-html="دریافت هدیه"
        >
          <div
            style="
              background-image: url('inviteFriends.jpeg');
              background-size: 100%;
              height: 250px;
            "
          ></div>
        </b-modal>
      </div>

      <div class="col-xl-5">
        <div
          class="card card-custom bgi-no-repeat bgi-no-repeat bgi-size-cover gutter-b"
          style="height: 180px; background-position: center"
          :style="{
            backgroundImage: `url(${backgroundImage('media/bg/bg-10.jpg')})`,
          }"
        >
          <!--begin::Body-->
          <div class="card-body d-flex flex-column">
            <!--begin::Title-->
            <a
              href="#"
              class="text-white text-hover-primary font-weight-bolder font-size-h6"
              >بسته های فعال
            </a>
            <a
              href="#"
              class="text-white text-hover-primary font-weight-bolder mt-3"
              style="font-size: 8pt"
              >شما هیچ بسته فعالی ندارید.</a
            >
            <!--                        <p href="#" class="text-dark-75 text-hover-primary font-weight-bolder pt-4">-->
            <!--                            {{ panelInfo.diff_day | currency }} روز باقی-->
            <!--                            مانده</p>-->
            <!--end::Title-->
            <div class="mt-12">
              <b-progress
                :max="panelInfo.expire"
                height="18px"
                v-b-tooltip.hover
                title="شما هیچ بسته ای ندارید."
                show-value
                :value="panelInfo.diff_day"
                :variant="
                  (panelInfo.expire * 20) / 100 < panelInfo.diff_day
                    ? 'primary'
                    : 'danger'
                "
                :striped="true"
                :animated="true"
              ></b-progress>
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Tiles Widget 3-->
      </div>
      <div class="col-xl-7">
        <!--begin::Mixed Widget 10-->
        <div
          class="card card-custom gutter-b"
          style="height: 180px; background-color: #ddeaf6"
        >
          <!--begin::Body-->
          <div
            class="card-body d-flex align-items-center justify-content-between flex-wrap"
          >
            <div
              class="pb-5 mb-5 col-md-5 d-none d-md-block"
              style="position: absolute; top: 0; left: 0; bottom: 0"
            >
              <img
                class="img-fluid"
                src="https://cdn.dribbble.com/users/1247188/screenshots/8699871/media/4676a06d00a58fe9678d80fe1f8bd776.jpg?compress=1&resize=400x300"
                alt=""
              />
            </div>
            <div class="col-md-7 py-0 my-0 px-0 mx-0 text-center">
              <h6 style="font-size: 10pt">
                سامانه را به دوستان خود معرفی کنید.
                <br />
                <span
                  class="btn-link text-primary line-height-lg"
                  v-b-modal.modalPopover
                  >هدیه</span
                >
                دریافت کنید.
              </h6>
              <input
                class="form-control"
                :maxlength="11"
                v-model="number"
                placeholder="شماره را وارد نمایید."
              />
              <button
                @click="inviteFriends"
                class="btn py-1 float-right btn-info mt-5"
              >
                دعوت کن!
              </button>
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Mixed Widget 10-->
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6">
        <!--begin::Tiles Widget 13-->
        <div class="card card-custom bgi-no-repeat gutter-b">
          <!--begin::Body-->
          <div class="card-body px-2 py-4">
            <div class="row">
              <div class="col-md-7 col-7 py-5 mt-5 pr-4">
                <h6
                  class="text-dark text-left font-weight-bolder line-height-lg"
                  style="font-size: 11pt"
                >
                  در هر لحظه با شما هستیم...
                </h6>
                <p class="mt-5">
                  <a
                    target="_blank"
                    :href="`${this.$sarveLandFront}/#/tickets/create`"
                    class="text-dark"
                  >
                    <span style="font-size: 7pt">
                      برای ارتباط با تیم پشتیبانی ما تیکت ثبت نمایید</span
                    >
                    <br />
                    <span class="btn btn-info py-1 mt-10 mb-0 pb-0"
                      >ثبت تیکت</span
                    >
                  </a>
                </p>
              </div>
              <div
                class="col-md-5 col-5 p-0"
                style="
                  height: 190px;
                  background-image: url(https://cdn3d.iconscout.com/3d/premium/thumb/customer-service-4471979-3735547.png);
                  background-position: left;
                  background-size: contain;
                "
              ></div>
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Tiles Widget 13-->
        <div class="row">
          <div class="col-xl-6">
            <!--begin::Tiles Widget 12-->
            <div
              @click="$router.push('billboard-register')"
              class="card card-custom gutter-b cursor-pointer"
              style="height: 160px"
            >
              <div
                class="card-body p-0 position-relative"
                style="
                  background-image: url('./media/completed.png');
                  background-size: 60%;
                  background-color: #f5f5f5;
                "
              >
                <div class="row mx-auto mt-5"></div>
                <div
                  class="text-dark font-weight-bolder font-size-h2 mt-20 pl-5"
                >
                  {{ repo.siteDone | currency | persianNum }}
                </div>
                <p class="font-size-h6 p-3 pl-5 pt-3">سفارش های تکمیلی</p>
              </div>
            </div>
            <!--end::Tiles Widget 12-->
          </div>
          <div
            @click="$router.push('billboard-register')"
            class="col-xl-6 cursor-pointer"
          >
            <div class="card card-custom gutter-b" style="height: 160px">
              <div
                class="card-body p-0 position-relative"
                style="
                  background-image: url('./media/saved.png');
                  background-size: 60%;
                  background-color: #f5f5f5;
                "
              >
                <div class="row mx-auto mt-5"></div>
                <div
                  class="text-dark font-weight-bolder font-size-h2 mt-20 pl-5"
                >
                  {{ repo.siteCount | currency | persianNum }}
                </div>
                <p class="font-size-h6 p-3 pl-5 pt-3">سفارش های ثبت شده</p>
              </div>
            </div>
            <!--end::Tiles Widget 12-->
          </div>
        </div>
      </div>
      <div class="col-xl-6">
        <!--begin::Mixed Widget 14-->
        <div class="card card-custom gutter-b card-stretch">
          <!--begin::Header-->
          <div class="card-body d-flex flex-column pt-0 mt-0 mb-0 pb-0">
            <!--begin::Chart-->
            <!--begin::User-->
            <div class="d-flex align-items-center mt-5">
              <div
                class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center"
              >
                <div
                  class="symbol-label"
                  :style="{
                    backgroundImage: `url('${
                      user.image !== 'http://127.0.0.1:8001/avatar/blank.jpg'
                        ? user.image
                        : 'https://cdn3d.iconscout.com/3d/premium/thumb/man-5692600-4743369.png '
                    }')`,
                  }"
                ></div>
                <i class="symbol-badge bg-success"></i>
              </div>
              <div>
                <a
                  href="#"
                  class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"
                >
                  {{ user.name | isEmpty }}
                </a>
                <div class="text-muted">
                  {{ user.username | isEmpty }}
                </div>
              </div>
            </div>
            <!--end::User-->
            <!--begin::Contact-->
            <div class="pt-12 pb-6">
              <div
                class="d-flex align-items-center justify-content-between mb-5"
              >
                <span class="font-weight-bold text-dark mr-2">ایمیل:</span>
                <span href="#" class="text-hover-info">{{
                  user.email ? user.email : "وارد نشده است."
                }}</span>
              </div>
              <div
                class="d-flex align-items-center justify-content-between mb-5"
              >
                <span class="font-weight-bold text-dark mr-2"
                  >شماره موبایل:</span
                >
                <span class="text-hover-info">{{ user.phone | isEmpty }}</span>
              </div>
              <div
                class="d-flex align-items-center justify-content-between mb-5"
              >
                <span class="font-weight-bold text-dark mr-2">نوع کاربر:</span>
                <span v-if="user.type" class="text-hover-info">{{
                  user.type ? "حقوقی" : "حقیقی"
                }}</span>
                <span v-else class="text-hover-info"
                  >اطلاعات پروفایل تکمیل نشده است</span
                >
              </div>
              <div
                class="d-flex align-items-center justify-content-between mb-5"
              >
                <span class="font-weight-bold text-dark mr-2">نوع کاربر:</span>
                <span v-if="panelInfo.title" class="text-hover-info">{{
                  panelInfo.title
                }}</span>
                <span v-else class="text-hover-info"
                  >اطلاعات پروفایل تکمیل نشده است</span
                >
              </div>
            </div>
            <!--end::Contact-->
            <button
              @click="goToProfile"
              class="btn btn-info font-weight-bold py-3 px-6 mb-2 text-center btn-block"
            >
              مشاهده پروفایل
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--end::Header-->
  </div>
  <!--end::Mixed Widget 14-->
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import { ir } from "../../../../check_domain_ir";

export default {
  name: "widget-9",
  data() {
    return {
      strokeColor: "#f86573",
      chartOptions: {},
      user: [],
      number: "",
      moreInfo: [],
      moreInfo_dup: {
        advertises: 0,
        numbers: 0,
      },
      timer: null,
      repo: "",
      panelInfo: [],
      series: [
        {
          name: "Net Profit",
          data: [20, 22, 30, 28, 25, 26, 30, 28, 22, 24, 25, 35],
        },
      ],
    };
  },
  components: {},
  methods: {
    goToProfile() {
      window.location.replace(this.$profileurl);
    },
    backgroundImage(path) {
      return process.env.BASE_URL + path;
    },
    getProfile() {
      this.requestApiGetCore("user").then(({ data }) => {
        this.user = data;
        // this.$store.state.user = data.data.name;
        // this.$store.state.userImage = data.data.image
      });
    },
    getPanel() {
      this.requestApiGetCore("currentPack").then(({ data }) => {
        this.panelInfo.data;
      });
    },
    getMoreInfo() {
      this.requestApiGet("user/more").then(({ data }) => {
        this.moreInfo = data;

        this.moreInfo_dup = this.moreInfo;
      });
    },
    getReports() {
      this.requestApiGet("admin/reports").then(({ data }) => {
        this.repo = data;
      });
    },
    inviteFriends() {
      if (this.number === "" || this.number.length < 11) {
        this.$nextTick(function () {
          this.$modal.error("خطا!", "شماره به درستی وارد نشده است.");
        });
        return;
      }
      this.requestInvite(`user/invite?phone=${this.number}`)
        .then((res) => {
          this.number = "";
        })
        .catch((error) => {
          this.$modal.error(
            "خطا!",
            "",
            error.response.data.message ||
              Object.keys(error.response.data.errors)
                .map((key) => {
                  return error.response.data.errors[key][0];
                })
                .join("\n")
          );
        });
    },
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
  },
  beforeMount() {
    this.getReports();
  },
  mounted() {
    this.getProfile();
    this.getPanel();
    // this.getMoreInfo();
  },
};
</script>
<style scoped>
.svg-icon {
  width: 3em;
  height: 3em;
}

.svg-icon path,
.svg-icon polygon,
.svg-icon rect {
  fill: #4691f6;
}

.svg-icon circle {
  stroke: #4691f6;
  stroke-width: 1;
}
</style>
